import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '../shared/components/alert/Alert';
import { Button } from '../shared/components/button/Button';

export function PasswordInput(props) {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordValue, setPasswordValue] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);

  // setting field type to "password", so browser does not remember text
  useEffect(() => {
    if (props.submitting) setShowPassword(false);
  }, [props.submitting]);

  const handleValueChange = (e) => {
    const { value } = e.target;
    const { id } = e.target;
    const el = document.getElementById(id);
    let valid = false;

    setPasswordValue(value);
    if (props.setMessage) props.setMessage('');
    if (props.clearError) props.clearError();
    if (props.resetDataError) props.resetDataError();

    if (id === 'password') {
      // Always pass value to parent, regardless of validation
      props.handlePassword(value);

      // Create an array and push all possible values that you want in password
      const matchedCase = [];
      matchedCase.push('[A-Z]'); // Uppercase Alpabates
      matchedCase.push('[0-9]'); // Numbers
      matchedCase.push('[a-z]'); // Lowercase Alphabates

      // Check the conditions
      let ctr = 0;
      for (let i = 0; i < matchedCase.length; i++) {
        if (new RegExp(matchedCase[i]).test(value)) {
          ctr++;
        }
      }
      if (ctr > 2 && value.length > 7) {
        valid = true;
        setPasswordError(false);
      } else {
        setPasswordError(true);
      }
      // check if matches with confirmed password (if any)
      if (props.confirmPassword?.length > 7) {
        if (props.confirmPassword !== value) {
          valid = false;
          setConfirmPasswordError(true);
        } else {
          setConfirmPasswordError(false);
        }
      }
    } else if (id === 'confirm_password') {
      // Always pass value to parent, regardless of validation
      props.handleConfirmPassword(value);

      if (value === props.password) {
        valid = true;
        setConfirmPasswordError(false);
      } else {
        setConfirmPasswordError(true);
      }
    }
    if (valid) {
      el.classList.remove('invalid');
    } else {
      el.classList.add('invalid');
    }
  };

  const handlePasswordPreview = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleConfirmPasswordPreview = (e) => {
    e.preventDefault();
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <>
      {props.visible ? (
        <div className="password_container">
          <label className="not_logged_label" htmlFor="password">
            {t('R024')}
          </label>
          <div className="password_field_wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              className="code_input "
              id="password"
              name="password"
              onChange={handleValueChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && props.onEnterKeyPress) {
                  e.preventDefault();
                  props.onEnterKeyPress();
                }
              }}
              value={passwordValue}
              aria-label={t('R024')}
            />
            <Button
              ariaPressed={showPassword}
              ariaLabel={showPassword ? t('R094') : t('R093')}
              onClick={handlePasswordPreview}
              variant="icon-only"
              icon={{
                faIconDefinition: showPassword ? faEye : faEyeSlash,
                color: 'white',
                size: 'sm',
                className: 'icon',
              }}
              color="pink"
            />
          </div>
        </div>
      ) : (
        <div className="password_container">
          <label className="not_logged_label" htmlFor="confirm_password">
            {t('R025')}
          </label>
          <div className="password_field_wrapper">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              className="code_input "
              id="confirm_password"
              name="confirm_password"
              onChange={handleValueChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && props.onEnterKeyPress) {
                  e.preventDefault();
                  props.onEnterKeyPress();
                }
              }}
              value={passwordValue}
              aria-label={t('R025')}
            />
            <Button
              ariaPressed={showConfirmPassword}
              ariaLabel={`${t('label.confirm')} ${showConfirmPassword ? t('R094') : t('R093')}`}
              onClick={handleConfirmPasswordPreview}
              variant="icon-only"
              color="pink"
              icon={{
                faIconDefinition: showConfirmPassword ? faEye : faEyeSlash,
                color: 'white',
                size: 'sm',
                className: 'icon',
              }}
            />
          </div>
        </div>
      )}
      {(passwordError || confirmPasswordError) && props.showError && (
        <Alert
          type="error"
          message={passwordError ? t('signin.password.error') : t('signin.confirmPassword.error')}
          id="password-error"
          isVisible
          isAssessive
        />
      )}
    </>
  );
}
